import PendoCard from '../../../../components/card/pendo-card.vue.js';
import PendoButton from '../../../../components/button/pendo-button.vue.js';
import PendoInput from '../../../../components/input/pendo-input.vue.js';
import PendoNotification from '../../../../components/notification/pendo-notification.js';
import PendoModal from '../../../../components/modal/pendo-modal.vue.js';
import moment from 'moment-timezone';
import get from 'lodash/get.js';

var script = {
  name: 'Note',
  components: {
    PendoCard,
    PendoButton,
    PendoInput,
    PendoModal
  },
  props: {
    note: {
      type: Object,
      required: true
    },
    activeNoteId: {
      type: String,
      default: undefined
    },
    displayAlert: {
      type: Object,
      required: true
    },
    activeUser: {
      type: Object,
      required: true
    },
    hasAdminAccess: {
      type: Boolean,
      default: false
    },
    noteAction: {
      type: Object,
      default: () => ({})
    },
    noteError: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      hover: false,
      isEditing: false,
      updatingNote: false,
      removingNote: false,
      showDeleteModal: false,
      localText: ''
    };
  },
  computed: {
    canEditNote() {
      return get(this.displayAlert, 'canEditNote', false);
    },
    canRemoveNote() {
      return get(this.displayAlert, 'canRemoveNote', false);
    },
    showEditIcon() {
      if (this.activeNoteId && this.activeNoteId !== this.note.rootVersionId) {
        return false;
      }
      return this.noteUserId === this.activeUser.id;
    },
    showDeleteIcon() {
      return this.hasAdminAccess || this.noteUserId === this.activeUser.id;
    },
    postedTimestamp() {
      return moment(this.note.createdAt).tz(moment.tz.guess()).format('hh:mm A');
    },
    noteTooLong() {
      return this.localText.length > 500;
    },
    hasEdits() {
      return this.note.createdAt !== this.note.lastUpdatedAt;
    },
    noteUserId() {
      return get(this.note, 'createdByUser.id', undefined);
    },
    isUpdatingNote() {
      return get(this.noteAction, 'update', false);
    },
    isRemovingNote() {
      return get(this.noteAction, 'remove', false);
    }
  },
  watch: {
    isUpdatingNote(newValue, oldValue) {
      if (this.updatingNote && !newValue && oldValue) {
        if (this.noteError.update) {
          PendoNotification({
            type: 'error',
            title: 'Note was not edited.',
            message: 'Looks like something went wrong when editing your note. Please try again.',
            duration: 3000
          });
        } else {
          this.toggleEditMode();
        }
        this.updatingNote = false;
      }
    },
    isRemovingNote(newValue, oldValue) {
      if (this.removingNote && !newValue && oldValue) {
        if (this.noteError.remove) {
          PendoNotification({
            type: 'error',
            title: 'Note was not deleted.',
            message: 'Looks like something went wrong when deleting your note. Please try again.',
            duration: 3000
          });
        } else {
          this.toggleDeleteModal();
        }
        this.removingNote = false;
      }
    }
  },
  methods: {
    toggleEditMode() {
      this.isEditing = !this.isEditing;
      if (this.isEditing) {
        this.localText = this.note.text;
        this.$emit('note-edited', this.note.rootVersionId);
      } else {
        this.$emit('note-edited', undefined);
      }
    },
    toggleDeleteModal() {
      this.showDeleteModal = !this.showDeleteModal;
    },
    updateNote() {
      this.updatingNote = true;
      this.$emit('update-note', {
        noteId: this.note.rootVersionId,
        text: this.localText,
        alert: this.displayAlert
      });
    },
    removeNote() {
      this.removingNote = true;
      this.$emit('remove-note', {
        alert: this.displayAlert,
        noteId: this.note.rootVersionId
      });
    }
  }
};

export { script as default };
//# sourceMappingURL=note.vue2.js.map
